import { useState, useEffect } from 'react';
import { useContext } from 'react';
import GaleriaImagenes from './GaleriaImagenes';
import { CarritoContext } from '../context/CarritoContext';
import '../styles/MasVisitados.css';

export default function MasVisitados() {
  const [productos, setProductos] = useState([]);
  const { agregarProducto } = useContext(CarritoContext);

  useEffect(() => {
    fetch('/api/dashboard')
      .then(r => r.json())
      .then(data => {
        if (data.top_visitados?.length) setProductos(data.top_visitados);
      })
      .catch(() => {});
  }, []);

  if (!productos.length) return null;

  return (
    <section className="mv-seccion">
      <div className="mv-titulo-wrap">
        <h2 className="mv-titulo">Lo más visto</h2>
        <div className="mv-titulo-linea" />
      </div>

      <div className="mv-grid">
        {productos.map(p => (
          <div key={p._id} className="mv-card">
            <div className="mv-galeria">
              <GaleriaImagenes
                imagen={p.imagen}
                imagenes={p.imagenes}
                nombre={p.nombre}
                productoId={p._id}
              />
              <span className="mv-badge">👁 {p.visitas}</span>
            </div>
            <div className="mv-card-info">
              <h3 className="mv-nombre">{p.nombre}</h3>
              <p className="mv-precio">${p.precio?.toLocaleString('es-AR')}</p>
              <button
                className="mv-btn-agregar"
                onClick={() => agregarProducto(p)}
              >
                🛒 Agregar
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
